'use client';
import styles from './MaxWidth.module.scss';
import clsx from 'clsx';

export const MaxWidth = ({
    children,
    className,
    ...props
}: {
    children: React.ReactNode;
    className?: string;
    ref?: React.RefObject<HTMLDivElement>;
}) => {
    return (
        <div className={clsx(styles.maxWidth, className)} {...props}>
            {children}
        </div>
    );
};

export default MaxWidth;
